var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1453.2 235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 220.06,
    height: 235,
    rx: 41.18,
    style: {
      fill: "#0077ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.14,463.3V558H244.52V488.92c.67-1.12,11.72-19.13,30.93-23.74A68.4,68.4,0,0,1,288.14,463.3Z",
    transform: "translate(-209.38 -386.08)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.9,473.13V558H295.28V463.36a67.57,67.57,0,0,1,12.32,2c10.91,2.79,19.94,7.29,30.51,7.72Z",
    transform: "translate(-209.38 -386.08)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.87,435V558H345.25V472.74C373.48,468.73,388.87,435,388.87,435Z",
    transform: "translate(-209.38 -386.08)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.82,518.47a33.22,33.22,0,0,1,6.84,20.72q0,17.91-11.85,27.65t-34,9.73H485.32V440.15h69.56q20.8,0,32.75,9.06t12,26.39q0,12-6.26,20.14a29.72,29.72,0,0,1-16.67,10.88Q589,509.52,595.82,518.47Zm-67.73-25.14h16.57q5.79,0,8.58-2.31t2.79-7.13q0-5-2.79-7.42t-8.58-2.41H528.09Zm28,46.72q2.79-2.2,2.79-7.22,0-9.83-11.37-9.83H528.09v19.27h19.46C551.41,542.27,554.26,541.53,556.13,540.05Z",
    transform: "translate(-209.38 -386.08)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.73,529.75H653q1,14.06,11.75,14.06a10.4,10.4,0,0,0,10-6.36H720a47.13,47.13,0,0,1-9.73,20.72,52.47,52.47,0,0,1-18.69,14.45,57.5,57.5,0,0,1-24.76,5.3q-16.19,0-28.8-6.75a47.92,47.92,0,0,1-19.66-19.36q-7-12.62-7-29.58t7-29.58A48,48,0,0,1,638,473.29q12.62-6.74,28.8-6.74t28.81,6.64a47.91,47.91,0,0,1,19.65,19q7,12.33,7,29.1A59.35,59.35,0,0,1,721.73,529.75ZM679,511.06q0-5.4-3.47-8.19a13.39,13.39,0,0,0-8.67-2.8q-11.37,0-13.29,11Z",
    transform: "translate(-209.38 -386.08)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.9,572.91A46.06,46.06,0,0,1,738.11,559a37,37,0,0,1-7.9-20h41a10.07,10.07,0,0,0,4.15,7.13,14.81,14.81,0,0,0,8.57,2.32,8.49,8.49,0,0,0,5.2-1.45,4.3,4.3,0,0,0,1.93-3.56q0-3.66-4.05-5.21a97.56,97.56,0,0,0-13.68-3.47,140.32,140.32,0,0,1-19.36-5,31.26,31.26,0,0,1-13.3-9.25Q735,513.94,735,502.38a32.75,32.75,0,0,1,5.3-18.2q5.29-8.19,15.7-12.91t25.24-4.72q22,0,34.4,10.79t14.93,28.13h-38a11.37,11.37,0,0,0-4-6.84,13,13,0,0,0-8.28-2.41,8.52,8.52,0,0,0-5,1.25,4.33,4.33,0,0,0-1.73,3.76c0,2.18,1.34,3.82,4,4.91a75.6,75.6,0,0,0,12.91,3.37,141.83,141.83,0,0,1,19.85,5.21,32.65,32.65,0,0,1,14.06,9.92q6,7,6,19.36a28.82,28.82,0,0,1-5.59,17.34q-5.6,7.71-16.09,12.14t-24.57,4.44Q768.74,577.92,756.9,572.91Z",
    transform: "translate(-209.38 -386.08)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915,540.15v36.42H898.81q-44.71,0-44.71-44.51V503.54H840.62V467.9H854.1V441.69h42.78V467.9h17.73v35.64H896.88v29.29q0,3.85,1.83,5.59t6.07,1.73Z",
    transform: "translate(-209.38 -386.08)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015,486.78a16.52,16.52,0,0,0-7.13-6.26,25.65,25.65,0,0,0-11.18-2.22q-12.33,0-19.07,8t-6.74,21.87q0,16,7.51,23.89t23.12,7.9q14.84,0,23.89-12h-34.1V497.76h69.56v42.78a82.19,82.19,0,0,1-24.47,26.1q-15.62,10.89-39.5,10.89-21.2,0-36.9-8.77a59.56,59.56,0,0,1-24.09-24.56q-8.37-15.8-8.38-36t8.38-36a59.74,59.74,0,0,1,24-24.56q15.61-8.77,36.61-8.77,26.78,0,43.64,12.91t19.95,35.07Z",
    transform: "translate(-209.38 -386.08)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135,472.81a37.55,37.55,0,0,1,19.65-5.69v45.67h-12.14q-12.13,0-17.82,4.24t-5.68,15v44.51h-42.78V467.9H1119v20A51.84,51.84,0,0,1,1135,472.81Z",
    transform: "translate(-209.38 -386.08)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.4,571.17a49.62,49.62,0,0,1-20.52-19.36q-7.43-12.62-7.42-29.58t7.42-29.58a49.68,49.68,0,0,1,20.52-19.36,67.84,67.84,0,0,1,59,0,49.8,49.8,0,0,1,20.52,19.36q7.41,12.63,7.42,29.58t-7.42,29.58a49.74,49.74,0,0,1-20.52,19.36,67.75,67.75,0,0,1-59,0Zm39.5-35q4-4.73,4-14t-4-14a13,13,0,0,0-20,0q-4,4.73-4,14t4,14a13.1,13.1,0,0,0,20.14,0Z",
    transform: "translate(-209.38 -386.08)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1453.72,467.9,1427.9,576.57h-48.17l-13.1-61.28-13.88,61.28h-48.17L1279,467.9h42.39L1330.4,534l14.07-66.08h45.66L1405,534.75l9.25-66.85Z",
    transform: "translate(-209.38 -386.08)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1530.4,540.15v36.42h-16.18q-44.7,0-44.7-44.51V503.54H1456V467.9h13.49V441.69h42.77V467.9H1530v35.64h-17.73v29.29q0,3.85,1.83,5.59t6.07,1.73Z",
    transform: "translate(-209.38 -386.08)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1652.08,479.65q10.5,12.53,10.5,33.91v63H1620V519q0-7.71-4.15-12.24a14.27,14.27,0,0,0-11.07-4.53q-7.14,0-11.18,4.53t-4,12.24v57.61h-42.77V434h42.77v50.49a38.68,38.68,0,0,1,13.39-12.53q8.38-4.81,20-4.82Q1641.56,467.12,1652.08,479.65Z",
    transform: "translate(-209.38 -386.08)",
    style: {
      fill: "#333"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1d39957896cbd19b7e2698b1483192f4.svg";
export { ForwardRef as ReactComponent };